import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/pages/FinishesPage";
import { GALLERY } from "@/lib/content";

// A richer, varied set for the dedicated gallery page
const TILES = [
  ...GALLERY,
  { label: "Slate Metallic — Basement Studio", image: GALLERY[1].image },
  { label: "Pearl Quartz — Commercial Kitchen", image: GALLERY[2].image },
  { label: "Charcoal Solid — Loading Bay", image: GALLERY[3].image },
];

export default function GalleryPage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        eyebrow="Recent Pours"
        title="A floor is the largest surface in any room."
        body="A wider look at finishes from recent residential, commercial, and industrial installs. Every one of these was mixed and poured on site."
      />

      <section className="py-16" style={{ background: "var(--ink)" }}>
        <div className="wrap">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-[260px] gap-4">
            {TILES.map((g, i) => (
              <Reveal key={g.label + i} delay={(i % 3) * 0.08} className={i % 5 === 0 ? "sm:col-span-2 lg:row-span-1" : ""}>
                <div data-testid="gallery-page-tile" className="group relative h-full overflow-hidden flex items-end p-5" style={{ border: "1px solid var(--line)" }}>
                  <img src={g.image} alt={g.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, rgba(0,0,0,0.72), transparent 55%)" }} />
                  <span className="relative z-[2] font-mono-lbl text-[11.5px]" style={{ color: "var(--champagne)" }}>{g.label}</span>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-14 flex flex-col items-start gap-4 py-12 px-8" style={{ border: "1px solid var(--line)", background: "var(--ink-2)" }}>
              <h2 className="font-serif text-3xl sm:text-4xl max-w-[620px]" style={{ color: "var(--champagne)" }}>
                Your floor could be the next one on this wall.
              </h2>
              <button onClick={() => { navigate("/"); setTimeout(() => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" }), 350); }} className="btn btn-primary mt-2" data-testid="gallery-quote">
                Request a free quote <ArrowRight size={16} />
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
